import React, { useState } from 'react';

const NavBar = () => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <nav className="fixed w-full z-50 top-0 start-0 bg-[#F3F0E9]/80 backdrop-blur-md border-b border-[#1A1A1A]/10">
            <div className="max-w-screen-xl flex flex-wrap items-center justify-between mx-auto p-4 md:p-6">

                {/* Logo / Brand */}
                <a href="/" className="flex items-center space-x-3 group">
          <span className="self-center text-2xl font-migra font-extrabold tracking-tighter text-[#1A1A1A]">
            PETITBOIS
          </span>
                </a>

                {/* Burger Button (Visible partout ou mobile seulement selon ton choix) */}
                <button
                    onClick={() => setIsOpen(!isOpen)}
                    type="button"
                    className="inline-flex items-center p-2 w-10 h-10 justify-center text-[#1A1A1A] rounded-lg hover:bg-[#1A1A1A]/5 focus:outline-none transition-colors"
                    aria-expanded={isOpen}
                >
                    <span className="sr-only">Ouvrir le menu</span>
                    {/* Icone dynamique : Change entre Hamburger et Croix */}
                    {!isOpen ? (
                        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 8h16M4 16h16" />
                        </svg>
                    ) : (
                        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    )}
                </button>

                {/* Menu Déroulant (Mobile/Overlay) */}
                <div className={`${isOpen ? 'block' : 'hidden'} w-full transition-all duration-300 ease-in-out`}>
                    <ul className="flex flex-col mt-4 font-migra font-extralight text-2xl space-y-4 py-8 border-t border-[#1A1A1A]/10">
                        <li>
                            <a
                            href="#informations"
                            onClick={() => setIsOpen(false)}
                            className="block py-2 text-[#1A1A1A] hover:translate-x-2 transition-transform"
                            >
                            Informations
                        </a>
                    </li>
                    <li>
                        <a
                        href="#carousel"
                        onClick={() => setIsOpen(false)}
                        className="block py-2 text-[#1A1A1A] hover:translate-x-2 transition-transform"
                        >
                        Photos
                    </a>
                </li>
                <li>
                    <a
                    href="#documents"
                    onClick={() => setIsOpen(false)}
                    className="block py-2 text-[#1A1A1A] hover:translate-x-2 transition-transform"
                    >
                    Documents
                </a>
            </li>
            <li>
                <a
                href="#terrains"
                onClick={() => setIsOpen(false)}
                className="block py-2 text-[#1A1A1A] hover:translate-x-2 transition-transform"
                >
                Nos parcelles
            </a>
        </li>
    <li>
    <a
        href="#faq"
        onClick={() => setIsOpen(false)}
        className="block py-2 text-[#1A1A1A] hover:translate-x-2 transition-transform"
        >
        Faq
    </a>
</li>
    <li>
        <a
        href="#contact"
        onClick={() => setIsOpen(false)}
        className="block py-2 text-[#1A1A1A] hover:translate-x-2 transition-transform"
        >
        Contact
    </a>
</li>
</ul>
</div>

</div>
</nav>
);
};

export default NavBar;